import { supabase } from "./createClient";

export async function getProjects() {
  try {
    const { data, error } = await supabase
      .from("projects")
      .select(
        `
          *,
          projectsExternalLinks (
            externalLinks:external_link_id (externalLink, label)
          )
        `
      )
      .neq("id", 7) // Exclude project with id 7
      .order("sort_order", { ascending: true });
    console.log("Raw data from Supabase:", data);

    if (error) {
      console.error(error);
      return data;
    }

    return data;
  } catch (error) {
    console.error("Unexpected error fetching projects:", error);
    return null;
  }
}

export async function getTechStack() {
  try {
    const { data, error } = await supabase.from("techStacks").select("*");
    if (error) {
      console.error("Error fetching tech stack:", error);
      return [];
    }
    console.log("Fetched tech stack data:", data); // Debugging line
    return data;
  } catch (error) {
    console.error("Unexpected error:", error);
    return [];
  }
}

export async function getPageHeaders() {
  try {
    const { data, error } = await supabase.from("pageHeaders").select("*");

    if (error) {
      console.error(error);
      return null;
    }
    return data;
  } catch (error) {
    return null;
  }
}

export async function getSocials() {
  try {
    const { data, error } = await supabase.from("socials").select("*");

    if (error) {
      console.error(error);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
}

export async function getRecommendations() {
  try {
    const { data, error } = await supabase
      .from("recommendations")
      .select()
      .order("id");
    if (error) {
      console.error(error);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
}
export async function getExpertice() {
  try {
    const { data, error } = await supabase.from("expertice").select();

    if (error) {
      console.error(error);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
}

export async function getTimeline() {
  try {
    const { data, error } = await supabase.from("timeline").select();
    if (error) {
      console.error(error);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
}

export async function getPortfolios() {
  try {
    const { data, error } = await supabase
      .from("portfolios")
      .select(
        `
        *,
        portfolioTeckStackJoin (
          techStacks:techStack_id (label, icon)
        )
      `
      )
      .order("id", { ascending: true });
    if (error) {
      console.error(error);
      return null;
    }

    return data;
  } catch (error) {
    return null;
  }
}
